import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  commentsContainer: {
    maxHeight: 300,
    maxWidth: 240,
    minWidth: "100%",
    overflowY: "auto"
  },
  popoverLoader: {
    marginTop: 35
  }
}));
